import _ from 'lodash';
export var EXPERIMENTS_SCOPE = 'albums'; // TODO: Change me!!!
export var TEMPLATE_MOTHER_SITE_METASITEID = '47f6cdef-1fd5-4527-a917-181a71465eac';
export var TRANSPARENT_IMAGE_URL = 'a9ff3b_a268304dd2124c829801c489448477a0~mv2.png';
export var TRANSPARENT_IMAGE_URL_WIDTH = 104;
export var TRANSPARENT_IMAGE_URL_HEIGHT = 48;
export var COVER_MAX_SIZE = 500;
export var FULLSCREEN_STYLEPARAMS_KEYS = [
    'defaultShowInfoExpand',
    'allowTitleExpand',
    'allowDescriptionExpand',
    'allowLinkExpand',
    'expandInfoPosition',
    'allowFullscreenExpand',
    'fullscreenLoop',
    'bgColorExpand',
    'actionsColorExpand',
    'titleFontExpand',
    'titleColorExpand',
    'descriptionFontExpan',
    'descriptionColorExpand',
    'galleryAlignExpand',
    'addToCartBackColorExpand',
    'addToCartFontExpand',
    'addToCartColorExpand',
    'addToCartBorderWidth',
    'addToCartBorderColor',
];
export var isValidAlbumForEnablingStore = function (albumData) {
    var template = albumData.template, _a = albumData.oldVersionTemplate, oldVersionTemplate = _a === void 0 ? {} : _a;
    return (!albumData.migratedFrom &&
        template &&
        template.version > 2 &&
        (_.isEmpty(oldVersionTemplate) ||
            (oldVersionTemplate.version && oldVersionTemplate.version > 2)));
};
//# sourceMappingURL=uou.js.map